import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { update_scan_token } from "../tools-network";
import { showTemporaryMessage } from "../components/Message";

const WRISTBAND_COLORS = [
    { value: 'white', hex: '#FFFFFF', border: true },
    { value: 'black', hex: '#000000' },
    { value: 'red', hex: '#DC2626' },
    { value: 'blue', hex: '#2563EB' },
    { value: 'green', hex: '#16A34A' },
    { value: 'yellow', hex: '#EAB308' },
    { value: 'pink', hex: '#EC4899' },
    { value: 'purple', hex: '#9333EA' },
    { value: 'orange', hex: '#EA580C' }
];

const ScanTokenColorChange = ({ loginToken, scanToken, updateListOfScanTokens, reportEditingState, isOtherEditing }) => {
    const { t } = useTranslation();

    // View the components that actually update the color
    const [enableColorChange, setEnableColorChange] = useState(false);

    // Only enable the submit button whenever the new color is not equal to the current color
    const [submitButtonEnabled, setSubmitButtonEnabled] = useState(false);
    const [newColor, setNewColor] = useState("white");

    // Make components inactive and show progress bar when update is in progress
    const [updateInProgress, setUpdateInProgress] = useState(false);

    useEffect(() => {
        if (reportEditingState) {
            reportEditingState(enableColorChange);
        }
    }, [enableColorChange]);

    useEffect(() => {
        setNewColor(scanToken?.color ?? "white");
    }, [scanToken]);

    useEffect(() => {
        const isEnabled = newColor !== (scanToken?.color ?? "white");
        setSubmitButtonEnabled(isEnabled);
    }, [newColor, scanToken]);

    async function submitUpdate() {
        setUpdateInProgress(true);
        const updateFields = { color: newColor };
        try {
            const res = await update_scan_token(loginToken, scanToken.token, updateFields);
            if (res.success) {
                showTemporaryMessage(t("scan_token_color_successfully_updated"), " ", 'success');
                setUpdateInProgress(false);
                updateListOfScanTokens();
                setEnableColorChange(false);
            } else {
                showTemporaryMessage("Update scan token FAILED!", res.msg, 'danger');
                setUpdateInProgress(false);
                setEnableColorChange(false);
            }
        } catch (err) {
            showTemporaryMessage("Update scan token FAILED!", err, 'danger');
            setUpdateInProgress(false);
            setEnableColorChange(false);
        }
    }

    const getColorInfo = (colorValue) => {
        return WRISTBAND_COLORS.find(c => c.value === colorValue) || WRISTBAND_COLORS[0];
    };

    return (
        <>
			{scanToken ? (
				<>
					{/* ENABLE COLOR UPDATE DIV */}
					{!enableColorChange && !isOtherEditing && (
						<button
							onClick={() => setEnableColorChange(true)}
							className="btn-secondary text-white px-4 py-2 rounded-md text-sm font-semibold transition ease-in-out hover:scale-105 disabled:bg-gray-400 disabled:cursor-not-allowed"
						>
							{t("update_color_of_scan_token")}
						</button>
					)}
                                            {enableColorChange && (
                                                <div>
                                                    <div className="flex flex-col w-full neumorp items-center p-4">
                                                        <div className="flex w-full justify-start mb-4">
                                                            <h4 className="text-xl">{t("update_color_of_scan_token")}</h4>
                                                        </div>

                                                        {/* Color picker */}
                                                        <div className="flex flex-wrap w-full gap-3 justify-center mb-4">
                                                            {WRISTBAND_COLORS.map((color) => (
                                                                <button
                                                                    key={color.value}
                                                                    onClick={() => setNewColor(color.value)}
                                                                    disabled={updateInProgress}
                                                                    className={`w-12 h-12 rounded-full transition-all ${
                                                                        newColor === color.value
                                                                            ? 'ring-4 ring-cyan-600 scale-110'
                                                                            : 'hover:scale-105'
                                                                    } ${color.border ? 'border-2 border-gray-300' : ''} disabled:opacity-50`}
                                                                    style={{ backgroundColor: color.hex }}
                                                                    title={t(`color_${color.value}`)}
                                                                    aria-label={t(`color_${color.value}`)}
                                                                >
                                                                    {newColor === color.value && (
                                                                        <div className="flex items-center justify-center">
                                                                            <svg
                                                                                className={`w-6 h-6 ${color.value === 'white' || color.value === 'yellow' ? 'text-gray-800' : 'text-white'}`}
                                                                                fill="none"
                                                                                stroke="currentColor"
                                                                                viewBox="0 0 24 24"
                                                                            >
                                                                                <path
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                    strokeWidth={3}
                                                                                    d="M5 13l4 4L19 7"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                    )}
                                                                </button>
                                                            ))}
                                                        </div>

                                                        <p className="text-sm text-gray-600 mb-4">
                                                            {t("currently_selected")}: <span className="font-semibold">{t(`color_${newColor}`)}</span>
                                                        </p>

                                                        <div className="flex w-full items-center justify-between mt-3 gap-4">
                                                            {/* SUBMIT BUTTON */}
                                                            <button
                                                                onClick={() => submitUpdate()}
                                                                disabled={!submitButtonEnabled || updateInProgress}
                                                                className="btn-secondary disabled:bg-gray-400 disabled:cursor-not-allowed transition ease-in-out hover:-translate-y-0.5 hover:scale-105"
                                                            >
                                                                {t("submit_change")}
                                                            </button>
                                                            {/* CANCEL BUTTON */}
                                                            <button
                                                                onClick={() => {
                                                                    setNewColor(scanToken?.color ?? "white");
                                                                    setEnableColorChange(false);
                                                                }}
                                                                className="text-red-700 w-auto px-3 font-semibold text-sm disabled:bg-gray-400 disabled:cursor-not-allowed hover:text-black"
                                                                disabled={updateInProgress}
                                                            >
                                                                {t("cancel")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div hidden={!updateInProgress} id='progress-bar'>
                                                        <progress />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : null}
        </>
    );
};

export default ScanTokenColorChange;
